import { render, staticRenderFns } from "./StepIndicarResponsavelAtendimento.vue?vue&type=template&id=4aeb3e7d&scoped=true"
import script from "./StepIndicarResponsavelAtendimento.vue?vue&type=script&lang=js"
export * from "./StepIndicarResponsavelAtendimento.vue?vue&type=script&lang=js"
import style0 from "./StepIndicarResponsavelAtendimento.vue?vue&type=style&index=0&id=4aeb3e7d&prod&lang=css"
import style1 from "./StepIndicarResponsavelAtendimento.vue?vue&type=style&index=1&id=4aeb3e7d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aeb3e7d",
  null
  
)

export default component.exports